import "../scss/404.scss"
function _404Page() {
    return <div>
        <head>
            <title>404 Page Not Found</title>
            
        </head>
        <body>
            <h1>404</h1>
            <p>Page not found</p>
        </body>

    </div>
}

export default _404Page